import React from 'react';

import CommunityComments from '@components/SideFeedItems/CommunityComments';
import RecommendedArticles from '@components/SideFeedItems/RecommendedArticles';
import SubscribeToTheBriefing from '@components/SideFeedItems/SubscribeToTheBriefing';
import UpcomingEvents from '@components/SideFeedItems/UpcomingEvents';

import { ScoopsRightRailProps } from './interfaces';

const ScoopsRightRail = ({
  mostPopularArticles,
  upcomingEvents,
  communityComments,
  briefingNewsletter,
}: ScoopsRightRailProps) => {
  return (
    <section
      className="mt-64 hidden flex-1 border-b-0 border-l-0 border-r-0 border-t border-solid border-grayscale-gray pt-12 md:mt-0 md:block md:border-l md:border-t-0 md:pl-28 md:pt-0 lg:pl-56"
      data-testid="side-feed"
    >
      {mostPopularArticles && mostPopularArticles.length > 0 && (
        <RecommendedArticles title="Most Popular" recommendedArticles={mostPopularArticles} />
      )}
      <SubscribeToTheBriefing briefingNewsletter={briefingNewsletter} />
      {upcomingEvents && upcomingEvents.length > 0 && (
        <UpcomingEvents upcomingEvents={upcomingEvents} />
      )}
      {communityComments && communityComments.length > 0 && (
        <CommunityComments communityComments={communityComments} />
      )}
    </section>
  );
};

export default ScoopsRightRail;
